/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_New_Version_DescriptionInputs */

const en_app_new_version_description = /** @type {(inputs: App_New_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app has been updated. Reload the page to keep using the latest version.`)
};

const pt_br2_app_new_version_description = /** @type {(inputs: App_New_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O app foi atualizado. Recarregue a página para continuar usando a versão mais recente.`)
};

/**
* | output |
* | --- |
* | "The app has been updated. Reload the page to keep using the latest version." |
*
* @param {App_New_Version_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const app_new_version_description = /** @type {((inputs?: App_New_Version_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_New_Version_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_new_version_description(inputs)
	return pt_br2_app_new_version_description(inputs)
});